var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#707070",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0 0v-586.66 586.66Zm84-91.33H690q9.67 0 14.5-9t-1.17-17.67l-114.66-153q-5.34-6.66-13.34-6.66T562-457.67L447.33-308l-78.66-107q-5.34-6.67-13.34-6.67T342-415l-84 110.33q-6.67 8.67-1.83 17.67 4.83 9 14.5 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageThumbnail);
export default __webpack_public_path__ + "static/media/image_thumbnail.120080ed557390934774b4a0dc716609.svg";
export { ForwardRef as ReactComponent };